/**
 * @generated SignedSource<<cd69e03d733602b4d74970124f46731c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateWidgetSpaceInput = {
  positionX: number;
  positionY: number;
  spaceId: string;
};
export type WACategoryOrgSpaceMutation$variables = {
  storecastId: string;
  widget: CreateWidgetSpaceInput;
};
export type WACategoryOrgSpaceMutation$data = {
  readonly dashboard: {
    readonly createWidgetSpace: {
      readonly id: string;
    };
  };
};
export type WACategoryOrgSpaceMutation = {
  response: WACategoryOrgSpaceMutation$data;
  variables: WACategoryOrgSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widget"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "widget"
          }
        ],
        "concreteType": "WidgetSpace",
        "kind": "LinkedField",
        "name": "createWidgetSpace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WACategoryOrgSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WACategoryOrgSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0a0c658787caa8a12d618b93bbb4fbec",
    "id": null,
    "metadata": {},
    "name": "WACategoryOrgSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation WACategoryOrgSpaceMutation(\n  $storecastId: ID!\n  $widget: CreateWidgetSpaceInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetSpace(widget: $widget) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4db132cddb7f6ef63ece0ccffe54d433";

export default node;
